import {
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getTags } from 'store/tags/actions';
import {
  getTags as getTagsSelector,
  getTagsLoadingState,
  getTagsOptions,
  getTagsLabelMap, getTagsLabelToIDMap,
} from 'store/tags/selectors';

const useTagList = (skip = true, defaultSnapshot = {}) => {
  const [query, onQueryChange] = useState('');
  // const debouncedQuery = useDebounce(query, 0);
  const dispatch = useDispatch();
  const data = useSelector(getTagsSelector);
  const isLoading = useSelector(getTagsLoadingState);
  const options = useSelector(getTagsOptions);
  const labelMap = useSelector(getTagsLabelMap);
  const nameMap = useSelector(getTagsLabelToIDMap);

  useEffect(() => {
    if (!skip && (query || (!query && options.length))) {
      dispatch(getTags({ name: query }));
    }
  }, [query, skip]);

  return useMemo(() => {
    return {
      data,
      isLoading,
      options,
      labelMap,
      onQueryChange,
      nameMap,
    };
  }, [isLoading, labelMap, nameMap]);
};

export default useTagList;
